/* eslint-disable @next/next/no-img-element */
import { Editor } from '@tinymce/tinymce-react';
import { isEmpty } from 'lodash';
import { useState, useRef, useEffect } from "react";

export default function EditorComponent({ content: contentParent, editorId, onChangeContent }) {
    const [content, setContent] = useState(contentParent || '');
    // const [initContent, setInitContent] = useState(contentParent || '');

    // useEffect(() => {
    //     if( isEmpty(contentParent) ) return;
    //     setInitContent(contentParent);
    // }, [contentParent]);
    console.log('ssss');
    useEffect(() => {
        if( isEmpty(contentParent) ) return;
        setContent(contentParent);
    }, [contentParent]);

    //Update trạng thái của Parent khi update nội dung
    useEffect(() => {
        onChangeContent(editorId, content);
    }, [content]);

    const editorConfig = {
        height: 200,
        license_key: 'gpl', // Chấp nhận điều khoản GPL
        menubar: false,
        plugins: [
            'advlist autolink lists link charmap print anchor',
            'searchreplace visualblocks',
            'media table paste code help',
            'lists',  // Plugin cho numlist và bullist
        ],
        toolbar: "accordion accordionremove | blocks | bold italic underline | align numlist bullist | link image | table media | lineheight outdent indent| forecolor backcolor",
        // autosave_ask_before_unload: true,
        // autosave_interval: '30s',
        // autosave_prefix: '{path}{query}-{id}-',
        // autosave_restore_when_empty: false,
        // autosave_retention: '2m',
        // image_advtab: true,
        // importcss_append: true,
        // image_caption: true,
        quickbars_selection_toolbar: 'bold italic | quicklink h2 h3 blockquote quickimage quicktable',
    };


    return <Editor
        key={editorId}
        id={`editor_${editorId}`}
        inline={true}
        tinymceScriptSrc="/plugins/tinymce/js/tinymce/tinymce.min.js"
        init={editorConfig}
        value={content || ""}
        onEditorChange={(newValue) => {
            setContent(newValue);
            onChangeContent(editorId, newValue);
        }}
    />;
}
